import { Avatar, Button, Grid, IconButton, InputAdornment, TextField, Typography, makeStyles } from '@material-ui/core'
import { KeyboardDatePicker } from '@material-ui/pickers'
import React, { useEffect, useRef, useState } from 'react'
import { Controller, useForm, useFormContext } from 'react-hook-form'
import { GlobalTextField } from '../../../Core/Input/ControlledTextField'
import EventIcon from '@material-ui/icons/Event'
import { EMAIL_REGEX } from '../../../../Constants'
import { FirebaseConfigKey, FirebaseService } from '../../../../services/FirebaseService'
import { generalPhoneNumberRegex, isOver18 } from '../../../../services/utils'
import FlexView from 'react-flexview/lib'
import CloudUploadIcon from '@material-ui/icons/CloudUpload'

export const OdometerMotorcycleSection = ({ motorcycleDetails }) => {
  const imageFieldName = `image_${motorcycleDetails.id}`
  const milesFieldName = `miles_${motorcycleDetails.id}`
  const methods = useFormContext()
  const useStylesButton = makeStyles(theme => ({
    root: {
      backgroundColor: '#c7cbcf',
      '&:hover': {
        backgroundColor: '#b1b6bb',
      },
    },
  }))

  const classes = useStylesButton()

  const imageInputField = useRef(null)
  const [previewImage, setImg] = useState('')
  const [imgName, setImgName] = useState('')

  const motorcyclesStatus = !motorcycleDetails.old_fixed_price
    ? 'New'
    : !motorcycleDetails.new_fixed_price
    ? 'Removed'
    : motorcycleDetails.new_fixed_price === motorcycleDetails.old_fixed_price
    ? 'Not Changed'
    : 'Edited'
  const priceWasNotChanged = motorcyclesStatus === 'Not Changed'

  useEffect(() => {
    methods.register(imageFieldName, {
      required: !priceWasNotChanged && 'Required',
    })

    return () => {
      methods.unregister(imageFieldName)
    }
  }, [methods.register, methods.unregister, methods.getValues])

  const onPictureSelected = async event => {
    if (!event.target.files[0]) return
    setImg(URL.createObjectURL(event.target.files[0]))
    setImgName(event.target.files[0].name)
    methods.setValue(imageFieldName, event.target.files[0])
  }

  return (
    <React.Fragment>
      {motorcycleDetails.year} {motorcycleDetails.make} {motorcycleDetails.model} <b>({motorcyclesStatus})</b>
      <Grid container spacing={6} alignItems="flex-end">
        <Grid item xs={12} md={6}>
          <Typography className="grey">{`Miles (Previous value: ${motorcycleDetails.latest_odometer_value})`}</Typography>
          <TextField
            fullWidth
            disabled={priceWasNotChanged}
            name={milesFieldName}
            value={priceWasNotChanged ? motorcycleDetails.latest_odometer_value : null}
            inputProps={{ style: { textTransform: 'uppercase' } }}
            error={!!methods.errors[milesFieldName]}
            variant="outlined"
            type="number"
            helperText={methods.errors[milesFieldName] ? methods.errors[milesFieldName]?.message : ''}
            inputRef={methods.register({
              required: 'Required',
              validate: val => {
                const miles = parseInt(val, 0)
                return miles >= motorcycleDetails.latest_odometer_value
                  ? null
                  : `Miles must be more than ${motorcycleDetails.latest_odometer_value}`
              },
            })}
          />
        </Grid>
      </Grid>
      <Grid container spacing={6} alignItems="flex-end">
        <Grid item xs={12} md={6}>
          <Typography className="grey">{`Odometer image`}</Typography>
          <FlexView>
            <TextField
              disabled
              onClick={() => imageInputField.current.click()}
              fullWidth
              variant="outlined"
              label="Upload Image"
              error={!!methods.errors[imageFieldName]}
              helperText={methods.errors[imageFieldName]?.message}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="start">
                    {!previewImage ? (
                      <Button
                        disabled={priceWasNotChanged}
                        className={classes.root}
                        variant="contained"
                        color="primary"
                        aria-label="upload-image"
                      >
                        <CloudUploadIcon className="white" />
                      </Button>
                    ) : (
                      <IconButton>
                        <Avatar aria-label="image-avatar" src={previewImage} />
                      </IconButton>
                    )}
                  </InputAdornment>
                ),
              }}
            />
          </FlexView>
          <input
            type="file"
            disabled={priceWasNotChanged}
            accept="image/*"
            id="file"
            onChange={onPictureSelected}
            ref={imageInputField}
            style={{ display: 'none' }}
          />
        </Grid>
      </Grid>
    </React.Fragment>
  )
}
